module.exports = __webpack_public_path__ + "static/media/webdev.3299501a.png";